import type { XingletInterface } from '../xinglet-helpers';
import { XingletWrapper } from '../xinglet-helpers';

import type { TemplateProps } from './';

export type TemplateTraditionalProps = TemplateProps;
export type TemplateTraditionalXinglet =
  XingletInterface<TemplateTraditionalProps>;

export const Traditional = XingletWrapper<TemplateTraditionalProps>(
  `@xing-com/crate-lebenslauf-templates-traditional`
);
